import { useEffect, useState } from "react"
import "../Styles/Component/VerifyOtp.css"
import { Input, PasswordInput, PinInput, TextInput } from '@mantine/core';
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { url } from "../db/url";
import { toast } from "react-toastify";


const ShopVerifyOtp = ({modal, onClose, email, type}) => {
    const [showModal, setShowModal] = useState(modal)
    const [loading, setLoading] = useState(false)
    const [otp, setOtp] = useState("")

    const navigate = useNavigate()

    useEffect(() => {
        setShowModal(modal)
    }, [modal])

    const handlePinChange = (value) => {
        setOtp(value)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        axios.post(`${url}/api/v2/shop/verify-otp`, {email, otp})
        .then(res => {
            console.log(res)
            setLoading(false)
            toast.success(res.data.message + " Please Sign In with your details")
            window.open(``, "_blank")
        }).catch(err => {
            setLoading(false)
            toast.error(err.response.data.message)
        })
    }

    const resendMail = () => {
        toast.info("Please wait")
        axios.post(`${url}/api/v2/shop/send-otp`, {email})
        .then(res => {
            console.log(res)
            toast.success(res.data.message)
        }).catch(err => {
            console.log(err)
            toast.error("Error sending otp")
        })
    }

    const handleClose = () => {
        setShowModal(modal)
        onClose()
    }

    return<>
            <section className={showModal ? "verify" : "hide"}>
            <div className="verifyWrapper">
                <form action="">
                    <div className="close" onClick={handleClose}>x</div>
                    <div className="formHeading">
                        <h2>Verify Email</h2>
                        <p>Please enter the 6-digit code sent to <b>{email}</b></p>
                    </div>

                    <div className="inputContainer">
                        <PinInput 
                            oneTimeCode 
                            inputMode="numeric"
                            length={7}
                            size={window.innerWidth <= 350 ? "sm" : window.innerWidth <= 500 ? "md" : "lg"}
                            className="otp"
                            value={otp}
                            onChange={handlePinChange}
                        />
                    </div>
                    <button className="btn" disabled={loading} onClick={handleSubmit}>{loading ? "Loadin..." : "Confirm"}</button>
                    <p className="lastChild">Didn't get a code? <span onClick={resendMail} style={{color: "dodgerblue"}}>Click to resend</span></p>
                </form>
            </div>
        </section>
    </>
}

export default ShopVerifyOtp